/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Clock1220 from 'DesignSystem/Svgs/Tysiav2Clock1220/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/DueDate/Trigger",
  setOuterRef
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let cardDueDateValueData = fromData.useDataFormat({ viewPath,
context: 'card',
path: 'due_date',
format: fromFormat.dateISOToDateShortReporting,
})
let constantData = 'Due date'
let aggregateData = fromAggregate.getValueOrDefault(cardDueDateValueData, constantData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 innerRef={setOuterRef}
 style={{'--pt-1-HFmAS': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pb-2-HFmAS': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-3-HFmAS': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pr-4-HFmAS': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--g-5-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2Clock1220
  viewPath={`${viewPath}/Tysiav2Clock1220`}
 width={dtSpaceLs}
 height={dtSpaceLs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 weight="medium"
 data="card.due_date"
 format="/Data/format.js dateISOToDateShortReporting"
 data="'Due date'"
 aggregate="/Data/aggregate.js getValueOrDefault"
 text={aggregateData}
/>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={12}
 height={12}
/>
</div>
{children}
</React.Fragment>)
}